import { useState, useEffect } from "react";
import apiParticipantes from "../api/Participantes/api-participantes";

export const useModalEstado = () => {
  const [codigoPropuesta, setCodigoPropuesta] = useState("");
  const [estado, setEstado] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");

  const actualizarEstado = async () => {
    if (codigoPropuesta && numeroDocumento && estado) {
      let endCode = await apiParticipantes.actualizarTipoP(codigoPropuesta, numeroDocumento, estado)
      setEstado(endCode.data.tipoP)
    }
  };

  useEffect(() => {
  }, [estado]);

  return {
    actualizarEstado,
    setCodigoPropuesta,
    codigoPropuesta,
    estado,
    setEstado,
    numeroDocumento,
    setNumeroDocumento
  };
};
